/**
 * The single Auth0 callback and logout URL for every app in this shell, forever.
 *
 * `redirect_uri` (sign-in) and `returnTo` (sign-out) must agree, and both must be
 * registered in the Auth0 application's **Allowed Callback URLs**, **Allowed Web
 * Origins** and **Allowed Logout URLs**. An unregistered value produces an Auth0
 * error page rather than a redirect, so they share this helper instead of each
 * building the URL and drifting apart.
 *
 * Deliberately ignores `location.pathname`. Its predecessor in the ruleset-builder
 * repo returned `origin + pathname`, which was right for a single app pinned at
 * `/sale-intake/` but is wrong here for two reasons:
 *
 *  1. Under a router, `pathname` is `/sale-intake` on a deep link and `/` on the
 *     home index, so the callback URL would vary per route and each one would need
 *     its own Auth0 registration — exactly the per-app friction the shell removes.
 *  2. `@auth0/auth0-vue` hardcodes `window.history.replaceState({}, '', '/')` when
 *     it handles the callback, so anything other than the root gets rewritten out
 *     from under the app regardless.
 *
 * The intended route survives login through `appState.target`, not through the
 * URL — see `session.selectTenant()`.
 */
export function appRootUrl(
    location: { origin: string } = window.location,
    base: string = import.meta.env.BASE_URL,
): string {
    return location.origin + base;
}
